import { showNewMessageToast } from "@/features/chat/components/NewMessageToast";
import { playChatSound } from "@/features/chat/utils/chatNotificationSound";
import type { AlertInboxItem } from "../types";

/** Room for a title and one line of message on the card. */
const PREVIEW_CHARS = 90;

/**
 * A SILENT alert arrives the way a chat message does (owner, 2026-11-02:
 * "if it is a silent, it needs to be in the popup, just like we get the
 * normal chat"): the same corner toast, the same chime, no modal. Clicking it
 * opens the alert in the popup; the caller marks the row read.
 */
export function showSilentAlertToast(item: AlertInboxItem, onOpen: () => void) {
  playChatSound();
  const message = item.message.replace(/\s+/g, " ").trim();
  showNewMessageToast({
    variant: "alert",
    senderName: item.createdBy?.name?.trim() || "Admin",
    title: item.title,
    preview: message.length > PREVIEW_CHARS ? `${message.slice(0, PREVIEW_CHARS - 1)}…` : message,
    duration: 8000,
    onClick: onOpen,
  });
}
